<template>
  <div class="app-map-page">
    <navigator
      headLine = "地图导航"
    ></navigator>
    <div class="app-other-map-view">
      <app-other-map-view :mapMessage="mapMessage"></app-other-map-view>
    </div>
  </div>
</template>
<script>
  import AppOtherMapView from '@/components/app/other/AppOtherMapView';
  export default {
    name:'',
    data(){
      return {
        mapMessage:{
          address:'上海金保证网络科技有限公司',
          latitude: 31.176228,
          longitude: 121.40004,
          name: '',
          phone: '021-61921332'
        }
      }
    },
    components:{
      'app-other-map-view':AppOtherMapView
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">

</style>
